// extracted by mini-css-extract-plugin
export default {"entityModalMobile":"EntityModalMobile_entityModalMobile__IMPVI","top":"EntityModalMobile_top__s91qz","title":"EntityModalMobile_title__4HdGO"};